import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import StateIcon from '../StateIcon'

const useStyles = makeStyles((theme) => ({
  rootAAA: {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    padding: 8,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText,
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center'
  },
  iconWrapper: { padding: '0 8px', display: 'flex' }
  // nameWrapper: {
  //   display: 'block',
  //   maxWidth: '88px',
  //   whiteSpace: 'nowrap',
  //   overflow: 'hidden',
  //   textOverflow: 'ellipsis'
  // }
}))

const HousesTooltipState = ({ id, name }) => {
  const classes = useStyles()

  return (
    <div className={classes.rootAAA}>
      <div className={classes.iconWrapper}>
        <StateIcon houseId={id} width="20px" className={classes.stateIcon} />
      </div>
      <Typography className={classes.nameWrapper} variant="h4">
        {name}
      </Typography>
    </div>
  )
}
export default HousesTooltipState
